import template from './report_leave_cycles.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveCyclesViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.leave_taken_full = ko.observableArray('');
		this.show_hint = ko.observable(true);
		this.show_no_data_message= ko.observable(false);

		this.selected_department.subscribe((newValue) => {
			this.leave_taken_full([]);
			this.show_hint(true);
			this.show_no_data_message(false);

			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
				this.current_department_id(null);
		});
	}

	async download_clicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('leave_taken_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'leave_taken_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
	
	update_click()
	{
		this.show_hint(false);
		this.page.updateData();
	}
}

class ReportLeaveCyclesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeaveCyclesViewModel(this);
		this.current_department_id = null;
	}

	init()
	{
		document.title = tr('Leave Cycles Report');
		window.current_page_title(tr('Leave Cycles Report'));
	}

	updateData()
	{
		if (this.viewModel.current_department_id() != null)
			this.updateReportData();
	}

	async updateReportData()
	{
		let data = {
			department_id: this.viewModel.current_department_id()
		};

		this.viewModel.leave_taken_full('');
		this.viewModel.loader(true);

		let res = await Grape.fetches.postJSON('/reports/leave_cycles', data);


		if (res)
		{
			this.viewModel.leave_taken_full(res);
			this.viewModel.show_hint(false);
			this.viewModel.loader(false);
		}
	}
}

export default {
	route: '[/]report/leave_cycles',
	page_class: ReportLeaveCyclesPage,
	template: template,
	template_filename: 'translation/report_leave_cycles'
};
